// extracted by mini-css-extract-plugin
export default {"container":"styles_container__c4E7X"};